import App from './../../App'
import {html, render } from 'lit-html'
import {gotoRoute, anchorRoute } from './../../Router'
import Auth from './../../Auth'
import Utils from './../../Utils'
import ProviderAPI from '../../ProviderAPI'
import UserAPI from '../../UserAPI'
import 'animate.css';



class HomeView {
  async init(){    
    console.log('HomeView.init')
    document.title = 'Home'    
    this.providers = null  
    this.render()    
    Utils.pageIntroAnim()    
    await this.getProviders()
    this.filterProviders()  
  }


  async getProviders(){
    try{
      this.provider = await ProviderAPI.getProviders()
      console.log(this.provider)
      this.render()
    }catch(err){
      Toast(err, 'error')
    }
  }


  clearFilterBtns(){
    const filterBtns = document.querySelectorAll('.filter-btn')
    filterBtns.forEach(btn => btn.removeAttribute("type"))

  }

  handlefilterBtn(e){
    console.log(e.target)

    //clear all filter button active(type = primary)
    this.clearFilterBtns()


    //set button active
    e.target.setAttribute("type", "primary")

    e.target.getAttribute("type", "primary")
    const field = e.target.getAttribute("data-field")
    const match = e.target.getAttribute("data-match")


    //extract field and match from the button
    console.log("field=", field)
    console.log("match=", match)


    //filter roommates
    this.filterProviders(field,match)
  }

  clearFilters(){
    this.getProviders()
    this.clearFilterBtns()
  }

  async filterProviders(field,match){
    //validate

    //for roomates filter to refresh
    this.provider = await ProviderAPI.getProviders()

    if (!field || !match) return
    let filteredProviders


    //occupation
    if(field == 'occupation'){
      filteredProviders = this.provider.filter(provider => provider.occupation == match)
     
    }



   

   

    

    //price
    if(field == 'price'){
      //getpriceRangeStart
      const priceRangeStart = match.split('-')[0]
      const priceRangeEnd = match.split('-')[1 ]
      console.log(priceRangeStart,priceRangeEnd)
      filteredProviders = this.provider.filter(provider => provider.price >= priceRangeStart && provider.price <= priceRangeEnd)
     
    }


    this.provider = filteredProviders
    this.render()

  }

  render(){
    const template = html`
      <va-app-header title="Home" user=${JSON.stringify(Auth.currentUser)}></va-app-header>


      <main>

        <section class="carousel">
      <div id="textarea" class="animate__animated animate__fadeInLeft">
        <h1 >Your home deserves <br><span>the best care.<span></h1>
        <p style="color:#fff;">No time to do your chores? That leak is getting on your nerves? <br> We’ll connect you to trustworthy professionals for the job. </p>
      </div>
       <div id="getstarted" class="animate__animated animate__fadeInLeft animate__delay-1s">
           <a class="pro" href="#homecontent">hire someone</a>

        </div>


          </section>


        <section id="homecontent" data-aos="fade-right">

        <div class="textarea2">
        
        <h2 >At your service.</h2>
        <p>Meet our professional home service providers.</p>
      </div>

      <div class="filter"> 

        <div class="searchbar">
            <sl-input type="search" placeholder="Search for something"  filled><sl-icon name="search" slot="prefix"></sl-icon></sl-input>
        </div>


        <div class="filter-btns">

        <sl-select placeholder="Occupation" > 

        <sl-menu-item name="occupation"  class="filter-btn"  value="Garderner" data-field="occupation" data-match="Garderner" @click=${this.handlefilterBtn.bind(this)}>Garderner</sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn"  value="Electrician" data-field="occupation"  data-match="Electrician" @click=${this.handlefilterBtn.bind(this)}>Electrician</sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn"  value="Masonry" data-field="occupation"  data-match="Masonry" @click=${this.handlefilterBtn.bind(this)}>Masonry</sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn"  value="Painter" data-field="occupation"  data-match="Painter" @click=${this.handlefilterBtn.bind(this)}>Painter</sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn" value="Plumber" data-field="occupation"  data-match="Plumber" @click=${this.handlefilterBtn.bind(this)}>Plumber</sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn"  value="Air Conditioner" data-field="occupation"  data-match="Air Conditioner" @click=${this.handlefilterBtn.bind(this)}></sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn" value="Wielder" data-field="occupation"  data-match="Wielder" @click=${this.handlefilterBtn.bind(this)}>Wielder</sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn"  value="Carpenter" data-field="occupation"  data-match="Carpenter" @click=${this.handlefilterBtn.bind(this)}>Carpenter</sl-menu-item>
        <sl-menu-item name="occupation"  class="filter-btn" value="PoolCare"  data-field="occupation" data-match="PoolCare" @click=${this.handlefilterBtn.bind(this)}>Pool Care</sl-menu-item>

        </sl-select>

        <div>
        <sl-select placeholder="Price" style="width:180px; margin-right: 30px; " > 

        <sl-menu-item class="filter-btn" value="0-999" size="small" data-field="price" data-match="0-999" @click=${this.handlefilterBtn.bind(this)}>Less than Rs1000</sl-menu-item>

        <sl-menu-item class="filter-btn" value="1000-2000" size="small" data-field="price" data-match="1000-2002" @click=${this.handlefilterBtn.bind(this)}>RS 1000-2000</sl-menu-item>

        <sl-menu-item class="filter-btn" value="2000-3000" size="small" data-field="price" data-match="2000-3000" @click=${this.handlefilterBtn.bind(this)}>Rs 2000-3000</sl-menu-item>

        <sl-menu-item class="filter-btn" value="3000-5000" size="small" data-field="price" data-match="3000-5000" @click=${this.handlefilterBtn.bind(this)}>Rs 3000-4000</sl-menu-item>

        </div>

        <sl-button @click=${this.clearFilters.bind(this)} type="primary" >Clear Filters</sl-button>

        
          
      
        </div>


        </div>
        


      </div>

            
            
            <div class="categories">

       
            ${this.provider == null? html`
            <sl-spinner></sl-spinner>
            ` : html`
            ${this.provider.map(provider => html`
            
            

                <va-provider style="margin-right:7%;"
                name="${provider.name}"
                price="${provider.price}"
                description="${provider.description}"
                image="${provider.image}"
                occupation="${provider.occupation}"
                experience="${provider.experience}"
                user="${JSON.stringify(provider.user)}"
                email="${JSON.stringify(provider.user.email)}"
                address="${JSON.stringify(provider.user.address)}"
                phone="${JSON.stringify(provider.user.phone)}"
               
                >
                  
                
                
                
                </va-provider>

                `)}`}
      
        
          
                
                 
          
              </div>


             

              


        </section>

        <section id="aboutus" data-aos="fade-up">
            <div class="textarea2" >
          
            <h1  style="font-size:16px; font-weight:700; color: #FFFFFF; margin-bottom: 20%;">ABOUT <span>US<span></h1>
            <h2 class="abttitle" style="color: #FFFFFF;">Why we are here.</h2>


            <p class="abtpara" style=" color: #FFFFFF;" >Our mission is to create a platform that allows both service provider and Client to have an easy and fast way to interact so that there work can be delivered fast and easily. <br><br>
            Our mission is to create a platform that allows both service provider and Client to have an easy and fast way to interact so that there work can be delivered fast and easily. </p>
            </div>

            <div class="aboutusimg"></div>
        </section>

      







      </main>

        

        <footer>


        <div class="icons">

        <sl-icon name="facebook"></sl-icon>
        <sl-icon name="twitter"></sl-icon>
        <sl-icon name="instagram"></sl-icon>
        <sl-icon name="whatsapp"></sl-icon>

       


       
        </div>
        
        </footer>
        
     
     
    `
    render(template, App.rootEl)
  }
}

export default new HomeView()